import { render, staticRenderFns } from "./DocumentAnonymization.vue?vue&type=template&id=1595f830"
import script from "./DocumentAnonymization.vue?vue&type=script&lang=js"
export * from "./DocumentAnonymization.vue?vue&type=script&lang=js"
import style0 from "./DocumentAnonymization.vue?vue&type=style&index=0&id=1595f830&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports